module.exports = {"TXTCLI_City":{"id":"TXTCLI_City","defaultMessage":"Πόλη","flags":["TRACK"],"track":"City"}}